import { render, staticRenderFns } from "./vsPagination.vue?vue&type=template&id=558b9ed6&"
import script from "./vsPagination.vue?vue&type=script&lang=js&"
export * from "./vsPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsPagination.vue"
export default component.exports